var VCA = VCA || {};

VCA.HowToVideos = (function ($) {

    var ui = {};

    // stops video play when modal is closed by stripping src from iframe
    function init() {
        $('.how-to-videos__col').each(function() {
            $(this).on('hide.bs.modal', function (e) {
                $('iframe', this).attr("src", $('iframe', this).attr("src"));
            });
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.HowToVideos.init();
});